export default __webpack_public_path__ + "static/media/logo.fa78c7ed.svg";